export class WKTObject {
    constructor(
        readonly srid: number,
        readonly wkt: string,
        readonly egengeometri: boolean = null,
        readonly forenklet: boolean = null
    ) {}
}
